import React from 'react'
import { motion } from 'framer-motion'

// Components
import Menu from 'components/layout/Header/Menu'

// Third Party
import styled from 'styled-components'
import Topmenu from './Topmenu'

const Wrapper = styled.div`
  & ul {
    display: flex;
    align-items: center;
    list-style: none;
    margin-bottom: 0;
  }
`

interface DesktopProps {
  fields: GatsbyTypes.WpComponent
  isSticky?: boolean
}

const Desktop: React.FC<DesktopProps> = ({ fields, isSticky }) => (
  <Wrapper className="d-none d-lg-flex">
    <div>
      {!isSticky && (
        <motion.ul
          className="justify-content-end pb-3"
          initial={{ x: 200 }}
          animate={{ x: 0 }}
          transition={{ duration: 0.35 }}
        >
          <Topmenu fields={fields} />
        </motion.ul>
      )}

      <ul className="position-relative ps-0 ps-xl-4">
        <Menu fields={fields} />
      </ul>
    </div>
  </Wrapper>
)

export default Desktop
